
/**
 * Get random value between min and max
 * @param {Int} min 
 * @param {Int} max 
 * @returns randomNumber
 */
export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    // max以下の値を返すようにするため、+1をしている
    max = Math.floor(max) + 1;
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

export const getTwoRandomInt = (min, max) => {
    var firstNumber = getRandomInt(min, max);
    var secondNumber;
    while (true) {
        var tmp = getRandomInt(min, max);
        if (firstNumber !== tmp) {
            var secondNumber = tmp;
            break;
        }
    }
    return [firstNumber, secondNumber];
}